import { NgModule } from '@angular/core';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { DialogService } from '../services/dialog.service';

@NgModule({
  imports: [MdbModalModule
  ], // Import MdbModalModule here
  providers: [DialogService], // Provide the custom service
})
export class DialogModule {}